import React from "react";
import { observer } from "mobx-react";
import { SatelliteMachineViewStore } from "../../store";
import { SatelliteMachineViewForm } from "./SatelliteMachineViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SatelliteMachineViewProps = {
  satelliteMachineViewStore: SatelliteMachineViewStore;
};

export const SatelliteMachineView: React.FC<SatelliteMachineViewProps> =
  observer(({ satelliteMachineViewStore }) => {
    return (
      <div>
        <SatelliteMachineViewForm
          satelliteMachineViewStore={satelliteMachineViewStore}
          name={satelliteMachineViewStore.nameValue}
          machineCode={satelliteMachineViewStore.machineCodeValue}
          satelliteType={satelliteMachineViewStore.satelliteTypeValue}
          region={satelliteMachineViewStore.regionValue}
          certificateExpiresAt={
            satelliteMachineViewStore.certificateExpiresAtValue
          }
          authTokenLastFour={satelliteMachineViewStore.authTokenLastFourValue}
          authTokenCreatedAt={satelliteMachineViewStore.authTokenCreatedAtValue}
          authTokenRotatedAt={satelliteMachineViewStore.authTokenRotatedAtValue}
          status={satelliteMachineViewStore.statusValue}
          authorizedAt={satelliteMachineViewStore.authorizedAtValue}
          authorizedByValue={satelliteMachineViewStore.authorizedByValue}
          suspendedAt={satelliteMachineViewStore.suspendedAtValue}
          suspendedByValue={satelliteMachineViewStore.suspendedByValue}
          suspensionReason={satelliteMachineViewStore.suspensionReasonValue}
          enabled={satelliteMachineViewStore.enabledValue}
          allowedTenantIds={satelliteMachineViewStore.allowedTenantIdsValue}
          proxyEnabled={satelliteMachineViewStore.proxyEnabledValue}
          proxyPort={satelliteMachineViewStore.proxyPortValue}
          proxyProtocols={satelliteMachineViewStore.proxyProtocolsValue}
          botEnabled={satelliteMachineViewStore.botEnabledValue}
          botMaxConcurrent={satelliteMachineViewStore.botMaxConcurrentValue}
          workerEnabled={satelliteMachineViewStore.workerEnabledValue}
          publicIp={satelliteMachineViewStore.publicIpValue}
          location={satelliteMachineViewStore.locationValue}
          countryCode={satelliteMachineViewStore.countryCodeValue}
          lastHeartbeatAt={satelliteMachineViewStore.lastHeartbeatAtValue}
          lastHeartbeatMetrics={
            satelliteMachineViewStore.lastHeartbeatMetricsValue
          }
          connectedAt={satelliteMachineViewStore.connectedAtValue}
          disconnectedAt={satelliteMachineViewStore.disconnectedAtValue}
          tunnelConnectedAt={satelliteMachineViewStore.tunnelConnectedAtValue}
          tasksVisibleColumns={satelliteMachineViewStore.tasksVisibleColumns}
          tasksSetColumnWiths={(x) =>
            satelliteMachineViewStore.tasksSetColumnWiths(x)
          }
          tasksRows={satelliteMachineViewStore.tasksRowsDyn}
          onPrint={(handlePrint: () => void) =>
            satelliteMachineViewStore.printSatelliteMachine(handlePrint)
          }
          onCancel={() => satelliteMachineViewStore.cancelSatelliteMachine()}
          onEdit={
            satelliteMachineViewStore.isEditEnabled
              ? () => satelliteMachineViewStore.editSatelliteMachine()
              : undefined
          }
        />
        <ErrorDialog
          open={satelliteMachineViewStore.errorDialogOpened}
          title={satelliteMachineViewStore.errorTitle}
          description={satelliteMachineViewStore.errorDescription}
          onClose={() => satelliteMachineViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
